//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      tabs: null
    }
  },
  computed: {
    ...mapGetters({ user: 'getUser' })
  },
  created: function () {
    this.tabs = {}
    const parentRoute = this.user.view === 'mobile' ? '/employeeInfo/' : '/user-settings/'
    this.tabs.general = {
      label: 'Общее',
      name: 'general',
      to: parentRoute + 'general'
    }
    if (this.$d_hasOperation('changePassword')) {
      this.tabs.security = {
        label: 'Безопасность',
        name: 'security',
        to: parentRoute + 'security'
      }
    }
    this.tabs.configuration = {
      label: this.user.view === 'mobile' ? 'Настройки' : 'Конфигурация',
      name: 'configuration',
      to: parentRoute + 'configuration'
    }

    const contractorDispatcher = this.$store.getters.getUser.roles.contractorDispatcher
    if (parentRoute !== '/employeeInfo/' && !contractorDispatcher) {
      this.tabs.notifications = {
        label: 'Оповещения',
        name: 'notifications',
        to: parentRoute + 'notifications'
      }
    }

    if (this.user.view !== 'mobile') {
      this.tabs.alarms = {
        label: 'НШС',
        name: 'alarmsSettings',
        to: parentRoute + 'alarmsSettings'
      }
    }
    this.tabs.extras = {
      label: 'Дополнительно',
      name: 'extras',
      to: parentRoute + 'extras'
    }
  }
}

